import { render, staticRenderFns } from "./BoMitra.vue?vue&type=template&id=69528ac0&scoped=true"
import script from "./BoMitra.vue?vue&type=script&lang=js"
export * from "./BoMitra.vue?vue&type=script&lang=js"
import style0 from "./BoMitra.vue?vue&type=style&index=0&id=69528ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69528ac0",
  null
  
)

export default component.exports